import React, { useState, useRef, useEffect } from "react";
import { useAuth } from '../helpers/authContext'; 
import { Link } from "react-router-dom";

interface ProfileDropdownProps {
  user: string;
  imageLink: string;
  onOpenLogin?: () => void;
}

const ProfileDropdown: React.FC<ProfileDropdownProps> = ({ user, imageLink, onOpenLogin }) => {
    const { logout } = useAuth();
    const [open, setOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const menuRef = useRef<HTMLDivElement | null>(null); 
    useEffect(() => {
      const handleClickOutside = (event) => {
        const menuNode = menuRef.current;
        if (menuNode && !menuNode.contains(event.target)) {
            handleClose();
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleToggle = () => {
        if (open) {
            handleClose();
        } else {
            setOpen(true);
        }
    };

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setOpen(false);
            setIsClosing(false);
        }, 300); // match animation duration
    };

    return (
      <div ref={menuRef} className="relative inline-block text-left">
        <button
          className="collapse-item user-logo-button"
          onClick={handleToggle}
        >
          <span className="">
            <img
              className="user-logo"
              src={imageLink}
              alt="User Avatar"
            />
          </span> 
        </button>

        {open && (
          <div className={`absolute dropdown-menu-profile-d ${isClosing ? 'dropdown-animate-out' : 'dropdown-animate-in'}`} style={{ minWidth: '200px' }}>
              <ul className="nav">
                  <li className="dropdown-menu-item-p li-hover">
                    <Link
                        to={`/u/${user}`}
                        className="dropdown-link"
                        onClick={() => setOpen(false)}
                        >
                        <b>@{user}</b>
                    </Link>
                  </li>

                  {onOpenLogin && (
                    <li className="dropdown-menu-item-p li-hover">
                      <a
                          className="dropdown-link"
                          onClick={() => {
                              setOpen(false);
                              onOpenLogin();
                          }}
                          style={{ cursor: 'pointer' }}
                          >
                          <i className="fas fa-exchange-alt" /> Switch Account
                      </a>
                    </li>
                  )}

                  <li className="dropdown-menu-item-p li-hover">
                      <Link
                          to={`/u/${user}`}
                          className="dropdown-link"
                          onClick={() => setOpen(false)}
                          >
                          <i className="fas fa-user" /> Profile
                      </Link>
                  </li>
                  <li className="dropdown-menu-item-p li-hover">
                      <Link
                          to={`/wallet/${user}`}
                          className="dropdown-link"
                          onClick={() => setOpen(false)}
                          >
                          <i className="fas fa-wallet" /> Wallet
                      </Link>
                  </li>
                  <li className="dropdown-menu-item-p li-hover">
                      <Link
                          to="/proposals"
                          className="dropdown-link"
                          onClick={() => setOpen(false)}
                          >
                          <i className="fas fa-bullseye" /> Proposals
                      </Link>
                  </li>
                  <li className="dropdown-menu-item-p li-hover">
                      <Link
                          to="/witnesses"
                          className="dropdown-link"
                          onClick={() => setOpen(false)}
                          >
                          <i className="fas fa-server" /> Witnesses
                      </Link>
                  </li>
                  <li className="dropdown-menu-item-p li-hover">
                      <Link
                          to="/settings"
                          className="dropdown-link"
                          onClick={() => setOpen(false)}
                          >
                          <i className="fas fa-cog" /> Settings
                      </Link>
                  </li>
                  
                  <div className="dropdown-divider-speem" />

                  <li className="dropdown-menu-item-p li-hover">
                      <Link
                          to="/about"
                          className="dropdown-link dropdown-link-muted"
                          onClick={() => setOpen(false)}
                          >
                          <i className="fas fa-info-circle" /> About Us
                      </Link>
                  </li>
                  <li className="dropdown-menu-item-p li-hover">
                      <Link
                          to="/faq"
                          className="dropdown-link dropdown-link-muted"
                          onClick={() => setOpen(false)}
                          >
                          <i className="fas fa-question-circle" /> FAQ
                      </Link>
                  </li>
                  <li className="dropdown-menu-item-p li-hover">
                      <Link
                          to="/privacy"
                          className="dropdown-link dropdown-link-muted"
                          onClick={() => setOpen(false)}
                          >
                          <i className="fas fa-user-shield" /> Privacy Policy
                      </Link>
                  </li>
                  <li className="dropdown-menu-item-p li-hover">
                      <Link
                          to="/terms"
                          className="dropdown-link dropdown-link-muted"
                          onClick={() => setOpen(false)}
                          >
                          <i className="fas fa-file-contract" /> Terms of Service
                      </Link>
                  </li>

                  <div className="dropdown-divider-speem" />

                  <li className="dropdown-menu-item-p li-hover">
                      <a 
                          className="dropdown-link"
                          onClick={() => {
                              logout();
                          }}
                          >
                          <i className="fas fa-sign-out-alt" /> Logout 
                      </a>
                  </li>
              </ul> 
          </div>
        )}
      </div>
    );
};

export default ProfileDropdown;
